import { render, staticRenderFns } from "./SettingsCustomWebpageEditView.vue?vue&type=template&id=1b39254c&scoped=true&"
import script from "./SettingsCustomWebpageEditView.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomWebpageEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39254c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b39254c')) {
      api.createRecord('1b39254c', component.options)
    } else {
      api.reload('1b39254c', component.options)
    }
    module.hot.accept("./SettingsCustomWebpageEditView.vue?vue&type=template&id=1b39254c&scoped=true&", function () {
      api.rerender('1b39254c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsCustomWebpageEditView.vue"
export default component.exports